import { withHTMLComponent } from '@updater-local/custom-element-v1';
import '../link';
import styles from './index.css';
import { track } from '../../common/analytics';
import { CLICK } from '@updater-core/lib/tracker';
import { DIY_ROUTE_SEQUENCE, ROUTES } from '../../constants';

// TODO this should become a React/Pre
const html = `
  <upd-moveiq-link id="diy">
    Explore Do-it-yourself Options
  </upd-moveiq-link>
  <upd-moveiq-link id="fsm">
    Explore Full-Service Options
  </upd-moveiq-link>
`;

const fallback = {
  dispatchRoute: (route) => {
    window.location.href = route;
  },
  STATES: {
    STEP_DIY_MOVE: '/diy-move',
    DASHBOARD: '/dashboard',
  },
};

const routerFallback = {
  goTo: (route) => console.error('No router passed cannot route to', route),
};

export default class Link extends withHTMLComponent(styles, html)() {
  static props = ['updStore', 'router'];

  connected() {
    this._exploreDiyOptions = this.shadowRoot.querySelector('#diy');
    this._exploreFsmOptions = this.shadowRoot.querySelector('#fsm');

    this._exploreDiyOptions.addEventListener('click', this._goToDiyOptions);
    this._exploreFsmOptions.addEventListener('click', this._goToFsmOptions);

    this._updStore = fallback;
  }

  disconnected() {
    this._exploreDiyOptions.removeEventListener('click', this._goToDiyOptions);
    this._exploreFsmOptions.removeEventListener('click', this._goToFsmOptions);
  }

  updated({ updStore = fallback, router = routerFallback }) {
    this._updStore = updStore;
    this._router = router;
  }

  _track = (event) => {
    const page = this.getAttribute('page');
    const postfix = page ? `_on_${page}_page` : '';
    track({
      verb: CLICK,
      object: `${event}${postfix}`,
    });
  };

  /* 
    Scope the event listener to this component instance
    By making them function props (not prototype methods)
    This way the this is bound to this component instance
  */
  _goToDashboard = () => {
    if (this._updStore) {
      this._updStore.dispatchRoute(this._updStore.STATES.DASHBOARD);
      this._track('go_to_dashboard');
    }
  };

  _goToDiyOptions = () => {
    if (this._router) {
      // TODO: should update state ?? and go to redirect landing?
      this._router.goTo(DIY_ROUTE_SEQUENCE[0]);
      this._track('go_to_diy');
    }
  };

  _goToFsmOptions = () => {
    if (this._updStore) {
      this._router.goTo(ROUTES.homeSize);
      this._track('go_to_fsm');
    }
  };
}

customElements.define('upd-moveiq-terminal-page-link', Link);
